import { Component } from "@angular/core";
import { ViewController, NavParams, Platform } from "ionic-angular";
import { AppConfig } from "../../app/app.config";

@Component({
  selector: "openaccount-search",
  templateUrl: "openaccountsearch.html",
})
export class OpenAccountSearch {
  userName = "";
  bonus = "";
  passWord = "";
  url;
  hostUrl = AppConfig.GetHostUrl();
  onlyvalue;
  copy;
  constructor(
    private viewCtrl: ViewController,
    private navpar: NavParams,
    private platform: Platform
  ) {
    // let u = navigator.userAgent;
    //     // 判断终端设备
    //     var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端
    //     var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    //     if (isAndroid) {
    //       this.url = AppConfig.GetHostUrl();
    //     }
    //     else if (isiOS) {
    //       this.url = AppConfig.GetHostUrl();
    //     }else{
    //       this.url = window.location.href;
    //     }
    // if(this.hostUrl == ""){
      this.url = window.location.href;
    // }
    // else{
    //   this.url = AppConfig.GetHostUrl();
    // }
    this.onlyvalue = navpar.data;
    this.userName =
      navpar.data.username != undefined ? navpar.data.username : "";
    this.bonus = navpar.data.bonus != undefined ? navpar.data.bonus : "";
    this.passWord =
      navpar.data.password != undefined ? navpar.data.password : "";
  }
  ionViewDidLoad() {
    this.copy = `会员名称:
${this.userName}
登录密码：
${this.passWord}
会员类型：
${this.onlyvalue.userType == "1" ? "代理" : "会员"}
会员奖金：
${this.onlyvalue.reward}
当前线路：
${this.url}`;
  }

  //关闭
  //2017-01-03
  dismiss(data?: any) {
    this.viewCtrl.dismiss(data);
  }
}



// WEBPACK FOOTER //
// ./src/pages/open-account/openaccountsearch.ts